import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareCodeIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 18 13.505' {...props}>
    <g>
      <path
        d='M5.626 11.07l-.492.493q-.098.098-.226.098t-.226-.098L.098 6.979Q0 6.88 0 6.753t.098-.227l4.584-4.583q.098-.099.226-.099t.226.099l.492.492q.099.098.099.226t-.099.226L1.761 6.753l3.865 3.865q.099.099.099.226 0 .128-.099.227zM11.44.577L7.77 13.274q-.039.128-.152.192-.113.064-.231.024l-.61-.167q-.128-.04-.192-.152-.064-.113-.024-.241L10.229.23q.04-.128.153-.191.113-.064.231-.025l.61.167q.128.04.192.153.064.113.024.24zm6.463 6.403l-4.584 4.584q-.098.098-.226.098t-.226-.098l-.492-.492q-.099-.099-.099-.227 0-.127.099-.226l3.865-3.865-3.865-3.866q-.099-.098-.099-.226t.099-.226l.492-.492q.098-.099.226-.099t.226.099l4.584 4.583q.098.099.098.227t-.098.226z'
        fill='currentColor'
      />
    </g>
  </SvgWrapper>
);

export const CodeIcon = memo(BareCodeIcon);
